/**
 * Created by nkarnik on 8/3/2016.
 */

import React, {Component} from 'react';
import Dimensions from 'react-dimensions'
import {Table, Column, Cell} from 'fixed-data-table';

import 'fixed-data-table/dist/fixed-data-table.css';

const TextCell = ({rowIndex, data, col, ...props}) => {
    return (
        <Cell {...props}>
            {data[rowIndex][col]}
        </Cell>
    )
};

const HeaderCell = ({i, onChangeHandler, bg, visibleIndexes}) => {
    if (i == 0)
        return (
            <Cell>Category / Attribute</Cell>
        );

    return (
        <div className="cbcontainer"> <input type="checkbox" data-id={i-1} checked={visibleIndexes.includes(i-1)} onChange={onChangeHandler} /></div>
    );
};

class Grid extends Component {

    onChangeHandler(evt) {
        this.props.onToggle(evt);
    }

    updateColors(colors){
        // Remove the border from the selected containers
        const selectedContainers =document.querySelectorAll('.cbcontainer.selected')
        for (let i =0; i<selectedContainers.length; i++){
            selectedContainers[i].style.borderTop = "1px solid lightgrey"
            selectedContainers[i].className = "cbcontainer"
        }

        // Color the containers that are selected
        if (colors != null && Object.keys(colors).length > 0) {
            const containers = document.querySelectorAll('.cbcontainer')

            for (let key in colors) {
                if (this.props.visibleIndexes.includes(parseInt(key))){
                    containers[key].style.borderTop = "8px solid " + colors[key]
                    containers[key].className += ' selected'
                }
            }
        }
    }


    componentDidUpdate(){
        this.props.updateGridColor()
    }

    render() {
        let data = this.props.filters ? this.props.filters : [];
        let len = data.length > 0 ? data[0].length : 0;

        if(len === 0) return (<div></div>);

        var columns = [];

        for (var i = 0; i < len; i++) {
            columns.push(
                <Column
                    width={i == 0 ? 230 : 100}
                    fixed={i == 0}
                    header={<HeaderCell i={i} visibleIndexes={this.props.visibleIndexes} onChangeHandler={this.onChangeHandler.bind(this)} />}
                    cell={<TextCell data={data} col={i}/>}
                    key={i}
                />
            )
        }

        return (
            <Table
                rowHeight={30}
                rowsCount={data.length}
                width={this.props.containerWidth}
                height={360}
                headerHeight={40}>

                {columns}
            </Table>
        )
    }
}

export default Dimensions()(Grid)


/** WEBPACK FOOTER **
 ** ./src/components/Grid.js
 **/